import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, Inject } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { BaseDto } from '@models/base/baseDto.model';
import { AccionesDialog, Paises, Roles } from '@models/base/identificadores.model';
import { ExpedienteSummaryDto } from '@models/expediente/expedienteSummary.model';
import { FueroService } from '@services/fuero/fuero.service';
import { JuridiccionService } from '@services/juridiccion/juridiccion.service';
import { UsuarioService } from '@services/usuario/usuario.service';
import { LoginService } from '@services/login/login.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { ButtonAddComponent } from 'src/app/component/button-add/button-add.component';
import { ButtonCancelDialogComponent } from 'src/app/component/button-cancel-dialog/button-cancel-dialog.component';
import { ButtonCloseDialogComponent } from 'src/app/component/button-close-dialog/button-close-dialog.component';
import { ButtonCloseComponent } from 'src/app/component/button-close/button-close.component';
import { ButtonDeleteAndCancelComponent } from 'src/app/component/button-delete-and-cancel/button-delete-and-cancel.component';
import { ButtonDeleteComponent } from 'src/app/component/button-delete/button-delete.component';
import { ButtonSaveComponent } from 'src/app/component/button-save/button-save.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { map, Observable, of, startWith } from 'rxjs';
import { DtoBase } from '@models/base/dtoBase.model';
import { PaisesService } from '@services/pais/paises.service';
import { PaisService } from '@services/pais/pais.service';
import { EmpresaUsuarioService } from '@services/empresaUsuario/empresaUsuario.service';
import { EmpresaUsuarioDto } from '@models/empresaUsuario/empresaUsuarioDto.model';
import { BuscarLocalidadComponent } from '@views/busquedas/buscar-localidad/buscar-localidad.component';
import { BuscarProvinciaGeorefComponent } from '@views/busquedas/buscar-provincia-georef/buscar-provincia-georef.component';
import { BuscarLocalidadGeorefComponent } from '@views/busquedas/buscar-localidad-georef/buscar-localidad-georef.component';
import { BuscarProvinciaLocalidadGeorefComponent } from '@views/busquedas/buscar-provincia-localidad-georef/buscar-provincia-localidad-georef.component';
import { LocalidadBasicDto } from '@models/localidad/localidadBasicDto.model';
import { UsuarioDto } from '@models/usuario/usuarioDto.model';
import { CreateUsuarioRequest } from '@models/usuario/createUsuarioRequest.model';
import { RolService } from '@services/rol/rol.service';
import { RolDto } from '@models/seguridad/roles/rolDto.model';
import { RolEmpresaService } from '@services/rolEmpresa/rolEmpresa.service';
import { UpdateUsuarioRequest } from '@models/usuario/updateUsuarioRequest.model';

@Component({
  selector: 'app-dialog-form-usuario',
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatDialogModule, ButtonCloseDialogComponent, A11yModule, CommonModule, MatExpansionModule, ButtonSaveComponent, ButtonDeleteAndCancelComponent, ButtonCloseComponent, MatFormFieldModule, MatCardModule, MatIconModule, MatButtonModule, MatDividerModule, NgxSpinnerModule, MatTableModule, MatSliderModule, MatSlideToggleModule, MatMenuModule, MatDialogModule, MatDatepickerModule, MatExpansionModule, MatRadioModule, MatSelectModule, MatInputModule, CommonModule, FormsModule, MatSortModule, ReactiveFormsModule, MatTooltipModule, MatPaginatorModule, MatRippleModule, MatNativeDateModule, MatTabsModule, ButtonCancelDialogComponent, ButtonAddComponent, MatCheckboxModule, ButtonDeleteComponent, MatAutocompleteModule, BuscarLocalidadComponent, ButtonAddComponent, BuscarProvinciaGeorefComponent, BuscarLocalidadGeorefComponent, BuscarProvinciaLocalidadGeorefComponent],
  templateUrl: './dialog-form-usuario.component.html',
  styleUrl: './dialog-form-usuario.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DialogFormUsuarioComponent {
  accionesDialog = AccionesDialog;
  roles!: RolDto[];
  empresaUsuarioDto!: EmpresaUsuarioDto;
  empresaUsuario: any;
  get f() { return this.form.controls; }
  form!: FormGroup;
  localData: any;
  formBuilder: FormBuilder = new FormBuilder;
  usuarioDto!: UsuarioDto;

  constructor(
    public dialogRef: MatDialogRef<DialogFormUsuarioComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private usuarioService: UsuarioService,
    private empresaUsuarioService: EmpresaUsuarioService,
    private router: Router,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private loginService: LoginService,
    private rolEmpresaService: RolEmpresaService
  ) {

  }

  ngOnInit(): void {
    this.empresaUsuarioDto = this.data || {};
    this.data.descripcion = this.data?.usuario?.userName || {};
    this.getAllRoles();
    this.setForm();
  }
  setForm() {
    const esEdicion = this.data.accion === AccionesDialog.Modificar;

    this.form = this.formBuilder.group({
      Id: [{ value: this.empresaUsuarioDto?.usuario?.id || null, disabled: esEdicion }, Validators.required],
      IdRol: [{ value: this.empresaUsuarioDto?.rol?.id || null, disabled: !esEdicion }, Validators.required],
      NombreUsuario: [{ value: this.empresaUsuarioDto?.usuario?.userName || null, disabled: esEdicion }, Validators.required],
      Nombre: [{ value: this.empresaUsuarioDto?.usuario?.nombre || null, disabled: esEdicion }, Validators.required],
      Apellido: [{ value: this.empresaUsuarioDto?.usuario?.apellido || null, disabled: esEdicion }, Validators.required],
      Correo: [{ value: this.empresaUsuarioDto?.usuario?.correo || null, disabled: esEdicion }, Validators.required],
      Telefono: [{ value: this.empresaUsuarioDto?.usuario?.telefono || null, disabled: esEdicion }, Validators.required],
      Direccion: [{ value: this.empresaUsuarioDto?.usuario?.direccion || null, disabled: esEdicion }]
    });
  }

  esFormularioValidoParaGuardar(): boolean {
    if (!this.form || !this.empresaUsuarioDto) return false;

    const formValue = this.form.value;
    const original = this.empresaUsuarioDto;

    return (
      // El único campo que puede cambiar es IdRol
      formValue.NombreUsuario === original.usuario?.userName &&
      formValue.Nombre === original.usuario?.nombre &&
      formValue.Apellido === original.usuario?.apellido &&
      formValue.Correo === original.usuario?.correo &&
      formValue.Telefono === original.usuario?.telefono &&
      formValue.Direccion === original.usuario?.direccion
    );
  }

  getAllRoles() {
    this.spinner.show("spRol");
    this.rolEmpresaService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spRol");
          this.roles = data.filter(x => x.id != Roles.SuperAdministradores)
        },
        error => {
          this.spinner.hide("spRol");
          this.snackBar.showError(error, "Error");
        });
  }

  cancelar() {
    this.dialogRef.close({ event: AccionesDialog.Cancelar, data: this.data });
  }



  agregar() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.spinner.show("spUsuario")
    this.usuarioService.create(this.setCreateUsuarioRequest())
      .subscribe(
        data => {
          this.spinner.hide("spUsuario")
          this.snackBar.showSuccess('Registro creado con correctamente.', "Exito");
          this.dialogRef.close({ event: AccionesDialog.Agregar, data: this.data.usuario });
        },
        error => {
          this.spinner.hide("spUsuario")
          this.snackBar.showError(error, "Error");
          this.dialogRef.close({ event: AccionesDialog.Cancelar, data: null });
        })
  }

  modificar() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    let idRol = this.form.controls['IdRol'].value;

    this.spinner.show("spUsuario")
    this.empresaUsuarioService.actualizarRolUsuarioEmpresa(this.empresaUsuarioDto?.usuario?.id, idRol)
      .subscribe(
        data => {
          this.spinner.hide("spUsuario")
          this.snackBar.showSuccess('Registro modificado correctamente.', "Exito");
          this.dialogRef.close({ event: AccionesDialog.Modificar, data: this.data.usuario });
        },
        error => {
          this.spinner.hide("spUsuario")
          this.snackBar.showError(error, "Error");
          this.dialogRef.close({ event: AccionesDialog.Cancelar, data: null });
        })
  }

  eliminar() {
    this.spinner.show("spUsuario")
    this.empresaUsuarioService.deleteLogic(this.empresaUsuarioDto.id)
      .subscribe(
        data => {
          this.spinner.hide("spUsuario")
          this.snackBar.showSuccess('Registro eliminado correctamente.', "Exito");
          this.dialogRef.close({ event: AccionesDialog.Eliminar, data: this.data.usuario });
        },
        error => {
          this.spinner.hide("spUsuario")
          this.snackBar.showError(error, "Error");
          this.dialogRef.close({ event: AccionesDialog.Cancelar, data: null });
        })
  }

  setCreateUsuarioRequest(): CreateUsuarioRequest {

    const createUsuarioRequest = new CreateUsuarioRequest();

    createUsuarioRequest.nombre = this.form.controls['Nombre'].value;
    createUsuarioRequest.apellido = this.form.controls['Apellido'].value;
    createUsuarioRequest.telefono = this.form.controls['Telefono'].value == "" ? null : this.form.controls['Telefono'].value;
    createUsuarioRequest.descripcion = this.form.controls['Descripcion'].value;
    createUsuarioRequest.observaciones = this.form.controls['Observaciones'].value;
    createUsuarioRequest.correo = this.form.controls['Correo'].value == "" ? null : this.form.controls['Correo'].value;
    createUsuarioRequest.userName = this.form.controls['Correo'].value == "" ? null : this.form.controls['Correo'].value;
    createUsuarioRequest.direccion = this.form.controls['Direccion'].value == "" ? null : this.form.controls['Direccion'].value;
    createUsuarioRequest.codigoPostal = this.form.controls['CodigoPostal'].value == "" ? null : this.form.controls['CodigoPostal'].value;
    createUsuarioRequest.idRol = this.form.controls['IdRol'].value == "" ? null : this.form.controls['IdRol'].value;

    return createUsuarioRequest
  }

  setUpdateUsuarioRequest(): UpdateUsuarioRequest {

    const updateUsuarioRequest = new UpdateUsuarioRequest();

    updateUsuarioRequest.nombre = this.form.controls['Nombre'].value;
    updateUsuarioRequest.apellido = this.form.controls['Apellido'].value;
    updateUsuarioRequest.telefono = this.form.controls['Telefono'].value == "" ? null : this.form.controls['Telefono'].value;
    updateUsuarioRequest.direccion = this.form.controls['Direccion'].value == "" ? null : this.form.controls['Direccion'].value;

    return updateUsuarioRequest
  }



  onReset() {
    this.form.reset();
  }

  trackByusuarios(index: number, usuario: any): any { return usuario; }



  async getUsuarioById(id: number) {
    this.spinner.show("spUsuario")
    await this.usuarioService.getUserById(id)
      .subscribe(
        data => {
          this.spinner.hide("spUsuario")
          this.usuarioDto = data
          this.empresaUsuarioDto.usuario = data
          this.setForm();
        },
        error => {
          this.spinner.hide("spUsuario")
          this.snackBar.showError(error, "Error");
        })
  }

  esUrlValida(url: string): boolean {
    try {
      new URL(url);
      return true;
    } catch (_) {
      return false;
    }
  }

  abrirUrl(url: string): void {
    if (this.esUrlValida(url)) {
      window.open(url, '_blank');
    }
  }
}
